export type EventType =
| 'visible'
| 'hidden'
| 'token_expired'
| 'token_received'
| 'token_refreshed'
| 'token_error'
| 'system_error'
| 'login'
| 'logout'
| 'oauth_error';

export class AuthEvent {
  constructor(readonly type: EventType, readonly data?: any) {
  }
}

export interface OAuthErrorParams {
  error: string;
  error_description?: string;
  error_uri?: string;
  iss?: string;
  state?: string;
}

export enum OAuthErrorType {
  TEMPORARILY_UNAVAILABLE = 'temporarily_unavailable',
  AUTHENTICATION_EXPIRED = 'authentication_expired',
  ACCESS_DENIED = 'access_denied',
  INVALID_REQUEST = 'invalid_request',
  INVALID_SCOPE = 'invalid_scope',
  SERVER_ERROR = 'server_error',
  UNKNOWN = 'unknown'
}
